module.exports = new __parcel__URL__("bracket.9a688b64.svg").toString();